<template>
    <div class="widget-wrap">
        <div class="list-wrap">
            <template  v-for="(list, index) in RoomLists" :key="index">
                <div v-if="listOn">
                <transition name="slide" type="animation" > 
                    
                        <div class="list-item"
                            @mouseover="viewinfo(index)"
                            @click="joinroom(list.id)"  
                            v-if="index <=5"  
                            
                        >
                            <img :src="`${$store.state.serverPath}${list.icon}`" width="43" height="43">
                            <div class="over-area" :class="`item_${index}`" style="display:none"  @mouseleave="hideinfo(index)">
                                <img :src="`${$store.state.serverPath}${list.icon}`" width="63" height="63">
                                <div class="info-area">
                                    <div class="roominfo">
                                        <span class="roomtype">[미니게임]</span>
                                        <span class="roomtitle">{{ title(list.title) }}</span>
                                    </div>
                                    <div class="userinfo">
                                        <span class="room-ma">{{list.user.nic}}</span>
                                        <span class="count">1,111/1,900</span>
                                    </div>
                                </div>
                            </div>
                        </div>                    
                </transition>
                 </div>    
            </template>
        </div>

        <div class="waitingroom">
            <a href="javascript:void(0)" @click="popup()">채팅<br>대기실</a>
        </div>

    </div>
</template>
<script>
import { newPop } from '@/utils/popup.js';
import { auth } from '@/components/mixins/auth.js';
export default {
    data(){
        return{
            RoomLists:'',
            listOn:false
        }
    },
    mixins:[
        auth
    ]
    ,
    mounted(){
        this.fetchList();
    },
    
    methods:{
        async joinroom(index){
            if(!this.$store.getters.isAuthenticated)
            {
                let result = confirm("로그인이 필요합니다.");
                if(result){
                    //this.$router
                    this.$router.push({ name: 'auth_login'});
                    return;
                }else{  
                    return;
                }
            }
            //아이템 유무 판단
            // const ckitem =  await this.ckItem('chat_free','',index);
            // if(!ckitem){                
            //     return;                
            // }
            const url="/chat/room/"+index
            newPop('chat_window',url,'','',950,700)
        },
        
        title(title)
        {
            if(title.length > 20)
            {
                return title.substring(0,20)+"..."
            }else{
                return title
            }

        },
        viewinfo(index)
        {
            let selector = document.querySelector('.item_'+index)
            selector.style.display = "flex"
        },
        hideinfo(index)
        {
            let selector = document.querySelector('.item_'+index)
            selector.style.display = "none"
        },
        popup()
        {
            if(!this.$store.getters.isAuthenticated)
            {
                let result = confirm("로그인이 필요합니다.");
                if(result){
                    //this.$router
                    this.$router.push({ name: 'auth_login'});
                    return;
                }else{  
                    return;
                }
            }
           
            const url="/chat/lobby"
            newPop('chat_window',url,'','',950,700)
                    
        },
        async fetchList(){
            try {

                const response = await this.$store.dispatch("chat/fechChatroomList")
                console.log('await테스트',response);
                this.RoomLists = response;
                this.listOn = true;
            }catch(error)
            {
                console.log(error);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/ani_slide';
.widget-wrap{
    height:100%;
    width:65px;
    background:#fafafa;
    border: 1px solid #dee3eb;
    padding:10px;
    display: flex;
    flex-direction:column;
    justify-content: space-between;
    .list-wrap{
        .list-item{
            padding-bottom:5px;
            cursor: pointer;
            .over-area{
                margin-top:-57px;
                margin-left:-10px;
                width:400px;
                height: 65px;
                display: flex;
                position:absolute;
                border: 1px solid rgb(12, 75, 158);
                color:#fff;
                .info-area{
                    background:rgb(12, 75, 158);
                    flex: 1 1 auto;
                    font-size:12px;
                    font-family:dotum;
                    padding:15px 20px;
                    .userinfo{
                        display:flex;
                        justify-content: space-between;
                        .room-ma{
                            color:rgb(0, 255, 106);
                            font-weight:bold;
                        }
                    }
                }
            }
        }
    }
    .waitingroom{
        text-align: center;
        a{font-size:12px;text-decoration: underline;color:red}
    }
}
</style>
